/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import './PortalRichTextBlock.scss';

export const PortalRichTextBlock = function (props) {
  const { anchor, title, blurb, content } = props;

  return (
    <portal-rich-text id={anchor}>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <h2>
            <span>{title}</span>
          </h2>
          <h4 className="portal-section-blurb">{blurb}</h4>
          <div
            className="portal-section-rich-text"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    </portal-rich-text>
  );
};
PortalRichTextBlock.displayName = 'PortalRichTextBlock';
PortalRichTextBlock.propTypes = {
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  blurb: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
